import { worldNodeAssetManifest } from '../game/asset-manifest';

export type WorldNodeKind = keyof typeof worldNodeAssetManifest;

export function worldNodeKind(kind?: string): WorldNodeKind {
  return kind && Object.hasOwn(worldNodeAssetManifest, kind)
    ? (kind as WorldNodeKind)
    : kind === 'celestial'
      ? 'celestial_observatory'
      : kind === 'cache'
        ? 'market_exchange'
        : kind === 'tribe'
          ? 'civic_nexus'
          : kind === 'seasonal'
            ? 'verdant_waypoint'
            : 'glyph_archive';
}

export function worldNodeArt(kind?: string) {
  return worldNodeAssetManifest[worldNodeKind(kind)];
}

const sprites = new Map<string, HTMLImageElement>();
let pending: Promise<void> | undefined;

/** Six bounded raster sources, shared across atlas states; location updates never refetch art. */
export function loadWorldNodeSprites(): Promise<void> {
  pending ??= Promise.all(
    Object.values(worldNodeAssetManifest).map(
      (asset) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          const timeout = window.setTimeout(resolve, 8_000);
          img.onload = () => {
            window.clearTimeout(timeout);
            sprites.set(asset.id, img);
            resolve();
          };
          img.onerror = () => {
            window.clearTimeout(timeout);
            resolve();
          };
          img.src = asset.url;
        }),
    ),
  ).then(() => undefined);
  return pending;
}

export function worldNodeSprite(kind?: string): HTMLImageElement | undefined {
  return sprites.get(worldNodeArt(kind).id);
}
